module.exports = __webpack_public_path__ + "img/seller-img 1.dcf92550.png";